/* globals authorize, getInternetExplorerVersion, ga */
(function () {
	'use strict';

	angular
		.module('app.core')
		.controller('headerNavigation', headerNavigation);

	headerNavigation.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$translate', '$uibModal', '$experiments', '$sce',
		'globalConfigService', 'navigationService', 'notificationService', 'userService', 'userManagementService', 'localStorageService',
		'siteService', 'storeService', 'oldNavMargin', 'oldNavMarginCollapsed'
	];

	function headerNavigation($scope, $rootScope, $timeout, $state, $translate, $uibModal, $experiments, $sce, globalConfigService,
			navigationService, notificationService, userService, userManagementService, localStorageService,
			siteService, storeService, oldNavMargin, oldNavMarginCollapsed) {
		var adminConfig = storeService.getState().adminConfig;
		$rootScope.displayTabs = {};
		$rootScope.displayTabs.active = '';
		$rootScope.displayTabs.firstName = '';
		$rootScope.displayTabs.lastName = '';
		$rootScope.displayTabs.factoryName = '';
		$rootScope.displayTabs.factoryNdx = '';
		$rootScope.displayTabs.factorySearch = '';
		$rootScope.displayTabs.customerSearch = '';
		$rootScope.authorize = authorize;
		$scope.showSetup = showSetup();
		$scope.isSuperAdmin = isSuperAdmin();
		$scope.isAdmin = isAdmin(adminConfig.factory.id);
		$scope.isCustomerAdmin = isCustomerAdmin();
		$scope.isLeanDNACustomerAdmin = isLeanDNACustomerAdmin();
		$scope.changingSites = false;
		$scope.goToTabFirstView = navigationService.goToTabFirstView;
		$scope.pickRoleModal = pickRoleModal;
		$scope.chatEnabled = $experiments.isEnabled('chat-enabled');
		$scope.goToState = navigationService.goToState;
		var isLandingPageMyWork = _.startsWith($state.current.name, 'app.my-work');
		var ieVersion = getInternetExplorerVersion();
		$scope.displayTabs.isWindows10 = isWindows10();
		$scope.hideGlobalSearch = globalConfig.user.hideGlobalSearch;
		$scope.supplierView = globalConfig.user.supplierView;
		$scope.switchToUserRole = switchToUserRole;

		$scope.displayTabs.hideBrowserBanner = function () {
			globalConfigService.hideBrowserBannerForUser().then(function (response) {
				if (globalConfig && globalConfig.user) {
					globalConfig.user.hideBrowserBanner = true;
				}
			});
		};

		$scope.displayTabs.showBrowserBanner = function () {
			return ieVersion < 11 && ieVersion > -1 && globalConfig &&
				globalConfig.user && !globalConfig.user.hideBrowserBanner;
		};

		$scope.displayTabs.showIE11EndOfLifeBanner = function () {
			return ieVersion >= 11 && ieVersion < 12 && globalConfig;
		};

		jQuery('head').append('<meta name="viewport" content="width=device-width, initial-scale=1" />');

		// Authorization 'global' functions
		$rootScope.authz = {};
		$rootScope.authz.isAdmin = isAdmin;
		$rootScope.authz.isSuperAdmin = isSuperAdmin;
		$rootScope.authz.isLeanDNAAdmin = isLeanDNAAdmin;
		$rootScope.authz.isCustomerAdmin = isCustomerAdmin;
		$rootScope.authz.isLeanDNACustomerAdmin = isLeanDNACustomerAdmin;
		$rootScope.authz.isSuperOrCustomerAdmin= isSuperOrCustomerAdmin;

		function getUserProfile(siteId) {
			var authSite = globalConfig.user.authFacts[siteId];
			return authSite ? authSite.profileType : globalConfig.user.profileType;
		}

		function isSuperAdmin(siteId) {
			return (getUserProfile(siteId) === 'SuperSystemAdministrator');
		}

		function isAdmin(siteId) {
			var profileType = getUserProfile(siteId);
			return (profileType === 'SuperSystemAdministrator' ||
				profileType === 'SystemAdministrator');
		}

		function isLeanDNAAdmin(siteId) {
			return ($rootScope.authz.isSuperAdmin(siteId) ||
				($rootScope.authz.isAdmin(siteId) && globalConfig.user.userName.endsWith('@leandna.com')));
		}

		function isCustomerAdmin(siteId) {
			return isSuperAdmin(siteId) || globalConfig.user.isCustomerAdministrator;
		}

		function isLeanDNACustomerAdmin(siteId) {
			return isSuperAdmin(siteId) ||
				(globalConfig.user.isCustomerAdministrator && globalConfig.user.userName.endsWith('@leandna.com'));
		}

		function isSuperOrCustomerAdmin() {
			return globalConfig.user.isCustomerAdministrator || globalConfig.user.profileType === 'SuperSystemAdministrator';
		}

		function showSetup() {
			return isAdmin()
				|| (siteService.getAdminSitesByCustomer(globalConfig.customer.id).length)
				|| (globalConfig.user.userName.endsWith('@leandna.com'));
		}

		function switchToUserRole() {
			var body = {
				userNdx: globalConfig.user.id,
				switchType: 'REGULAR'
			};
			userManagementService.mimicSupplierRoleToRegularRole(body).then(function (result) {
				if (result.error) {
					$rootScope.$emit('toast', {
						'message': 'Error occurred, could not switch user session',
						'success': false
					});
					return;
				}
				var path = encodeURIComponent(window.location.pathname + window.location.hash);
				location.href = '/application/factory-switch.html?p=' + path;
			});
		}

		$scope.openSiteSubmenu = function () {
			event.stopPropagation();
			$scope.customerSubmenuOpen = false;
			$scope.customerSubmenuInputFocus = false;
			$scope.siteSubmenuOpen = true;
			$timeout(function () {
				$scope.siteSubmenuInputFocus = true;
			}, 100);
		};

		$scope.openCustomerSubmenu = function (event) {
			event.stopPropagation();
			$scope.siteSubmenuOpen = false;
			$scope.siteSubmenuInputFocus = false;
			$scope.customerSubmenuOpen = true;
			$timeout(function () {
				$scope.customerSubmenuInputFocus = true;
			}, 100);
		};

		$scope.closeSubmenusOnHover = function (event) {
			var $target = jQuery(event.target);
			if ($target.closest('.dropdown-submenu').length) {
				return;
			} else {
				closeSettingsSubmenus();
			}
		};

		function closeSettingsSubmenus() {
			$scope.customerSubmenuOpen = false;
			$scope.siteSubmenuOpen = false;
			$scope.customerSubmenuInputFocus = false;
			$scope.siteSubmenuInputFocus = false;
		};

		var retryTimeout;
		var connectionLostListener = $scope.$on('connectionLost', function () {
			if (!$scope.displayTabs.connectionLost) {
				$scope.displayTabs.connectionLost = true;
			}
			if (retryTimeout) {
				$timeout.cancel(retryTimeout);
			}
			$scope.displayTabs.retryTime = $rootScope.retryTime / 1000;
			$scope.displayTabs.activelyTryingMessage = false;
			countdownRetry($rootScope.retryTime / 1000);
		});

		$scope.retryNow = function () {
			$timeout.cancel(retryTimeout);
			$rootScope.$broadcast('cancelHttpTimeouts');
		};

		$scope.chooseCustomer = function (customerNdx) {
			navigationService.getLoginSiteForCustomer(customerNdx).then(function (data) {
				$scope.switchSite(data.factoryNdx);
			});
		};

		function countdownRetry(time) {
			if (time === 0) {
				$scope.displayTabs.activelyTryingMessage = true;
			} else {
				$scope.displayTabs.retryTime = time;
				retryTimeout = $timeout(function () {
					countdownRetry(time - 1);
				}, 1000);
			}
		}

		function getCustomersDropdownList() {
			navigationService.getCustomersForUser().then(function (data) {
				if (data && data.length) {
					$scope.displayTabs.customers = data;
					angular.forEach($scope.displayTabs.customers, function (customer) {
						if (customer.ndx === globalConfig.customer.id) {
							customer.selected = true;
						} else {
							customer.selected = false;
						}
					});
				}
			});

		}

		function getFactoriesDropdownList() {
			navigationService.getFactoriesForUserAndCustomer($scope.displayTabs.selectedCustomer).then(function (data) {
				if (data && data.length) {
					$scope.displayTabs.factories = data;
					angular.forEach($scope.displayTabs.factories, function (factory) {
						if (factory.id === globalConfig.factory.id) {
							factory.selected = true;
						} else {
							factory.selected = false;
						}
					});
				}
			});
		}

		$scope.switchSite = function (siteId) {
			$scope.changingSites = true;
			localStorageService.set('newSiteId', siteId);
			userService.switchSite(siteId);
		};

		var listener = function (event, toState) {
			$timeout(function () {
				var currentPageTitle = (toState.data && toState.data.pageTitle) ? getTranslatedPageTitle(toState.data.pageTitle) : 'LeanDNA';
				$rootScope.title = currentPageTitle;
			}, 0);
		};

		var stateChangeListener = $scope.$on('$stateChangeSuccess', listener);

		var rootStateChangeListener = $rootScope.$on('$stateChangeSuccess', function (
			event, toState, toParams, fromState, fromParams, options) {
			if (fromState && fromState.name) {
				$rootScope.previousStateName = fromState.name;
				$rootScope.previousStateParams = fromParams;
			}
		});

		function getTranslatedPageTitle(pageTitle) {
			var stringToTranslate = pageTitle;
			if (_.startsWith(stringToTranslate, 'LeanDNA')) {
				stringToTranslate = pageTitle.substr(8);
			}
			return 'LeanDNA ' + $translate.instant(stringToTranslate);
		}

		function getInventoryActionsNotifications() {
			notificationService.getUnreadInventoryActions().then(function (data) { });
		}

		function getDeploymentId() {
			notificationService.getDeploymentId().then(function (data) { });
		}

		function setFactoryInfoTooltipData(factoryNdx, factoryName) {
			$scope.displayTabs.factoryInfoTooltip = $sce.trustAsHtml(getFactoryInfoTooltipData(factoryNdx, factoryName));
		}

		function getFactoryInfoTooltipData(factoryNdx, factoryName) {
			return '<table border="2px solid white" style="background-color:black;color:white;">' +
				'<tr>' +
				'<td style="text-align:left;padding:4px">' + $scope.displayTabs.selectedCustomer + ' - ' + $scope.displayTabs.customerName + '</td>' +
				'</tr>' +
				'<tr>' +
				'<td style="text-align:left;padding:4px">' + (factoryNdx || $scope.displayTabs.factoryNdx) + ' - ' + (factoryName || $scope.displayTabs.factoryName) + '</td>' +
				'</tr>' +
				'</table>';
		}

		$scope.$on('$destroy', function () {
			stateChangeListener();
			rootStateChangeListener();
			connectionLostListener();
			document.removeEventListener('click', unfocusSettingsToggle);
		});

		var siteChangedModal;

		function openSiteChangedModal(newSiteId) {
			if (siteChangedModal) {
				siteChangedModal.close();
			}

			var oldSite = globalConfig.factory.alias;
			var oldCustomerId = globalConfig.customer.id;
			var oldCustomerName = globalConfig.customer.name;
			var newSite = globalConfig.user.authFacts[newSiteId].alias;
			var newCustomerId = globalConfig.user.authFacts[newSiteId].customerNdx;
			var newCustomerName = globalConfig.user.authFacts[newSiteId].customerName;
			if (oldCustomerId !== newCustomerId) {
				oldSite = oldCustomerName + ' - ' + oldSite;
				newSite = newCustomerName + ' - ' + newSite;
			}

			var modalScope = $scope.$new();
			modalScope.oldSite = oldSite;
			modalScope.newSite = newSite;
			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/core/navigation/site-changed-modal.html'
			};
			siteChangedModal = $uibModal.open(opts);

			modalScope.closeModal = function () {
				siteChangedModal.close();
			};

			modalScope.reloadPage = function () {
				window.location.reload();
			};
		}

		window.addEventListener('storage', function (event) {
			if (!$scope.changingSites && event.isTrusted && event.key === localStorageService.deriveKey('newSiteId')) {
				var newSiteId = parseInt(event.newValue);
				if (newSiteId !== globalConfig.factory.id) {
					openSiteChangedModal(newSiteId);
				} else if (siteChangedModal) {
					siteChangedModal.close();
				}
			}
			$scope.changingSites = false;
		});

		function init() {
			var search = location.search;
			var qpar = {};
			if (search && search.length > 0) {
				search = search.substring(1);
				var qParams = search.split('&');
				for (var i = 0; i < qParams.length; i++) {
					var qParam1 = qParams[i].split('=');
					if (qParam1 && qParam1.length && qParam1.length === 2) {
						qpar[decodeURIComponent(qParam1[0])] = decodeURIComponent(qParam1[1]);
					} else if (qParam1 && qParam1.length && qParam1.length === 3 && qParam1[0] === 'path') {
						qpar[decodeURIComponent(qParam1[0])] = decodeURIComponent(qParam1[1] + '=' + qParam1[2]);
					}
				}
			}

			var factoryName = globalConfig.factory.alias && globalConfig.factory.alias !== '' ? globalConfig.factory.alias : globalConfig.factory.name;
			$scope.displayTabs.logoUrl = '/application/managed-assets/customer-logos/' + globalConfig.customer.safeId + '-178x48.png';
			$scope.displayTabs.supplierPortal = globalConfig.user.role === 'Supplier';
			$scope.displayTabs.isSuperAdmin = isSuperAdmin();
			$scope.displayTabs.isAdmin = isAdmin(adminConfig.factory.id);
			$scope.displayTabs.isCustomerAdmin = isCustomerAdmin();
			$scope.displayTabs.isReadOnlyUser = globalConfig.user.profileType === 'ReadOnlyUser';
			$scope.displayTabs.isLeanDNAAdmin = isLeanDNAAdmin();
			$scope.displayTabs.isLeanDNACustomerAdmin = isLeanDNACustomerAdmin();
			$scope.displayTabs.hasInitiativeAuthorization = globalConfig.user.authFacts[adminConfig.factory.id].initAuthz;
			$scope.displayTabs.firstName = globalConfig.user.firstName;
			$scope.displayTabs.lastName = globalConfig.user.lastName;
			$scope.displayTabs.factoryName = factoryName;
			$scope.displayTabs.factoryNdx = globalConfig.factory.id;
			$scope.displayTabs.selectedCustomer = globalConfig.customer.id;
			$scope.displayTabs.customerName = globalConfig.customer.name;
			$scope.settingsTooltipHtml = '<b>' + globalConfig.user.firstName + ' ' + globalConfig.user.lastName + '</b><br/>' + factoryName;
			$scope.settingsDropdownProperties = {};
			$scope.closeSettingsDropdownOnEsc = closeSettingsDropdownOnEsc;
			$scope.settingsDropdownProperties.open = false;
			$scope.settingsTooltipProperties = {};
			$scope.settingsTooltipProperties.open = false;
			setFactoryInfoTooltipData();

			var settingsTooltipPromise;
			$scope.settingsTooltipStart = function () {
				if (settingsTooltipPromise) $timeout.cancel(settingsTooltipPromise);
				if ($scope.settingsDropdownProperties.open) return;
				settingsTooltipPromise = $timeout(function () {
					if (!$scope.settingsDropdownProperties.open) $scope.settingsTooltipProperties.open = true;
				}, 500);
			};
			$scope.settingsTooltipEnd = function () {
				$scope.settingsTooltipProperties.open = false;
				if (settingsTooltipPromise) $timeout.cancel(settingsTooltipPromise);
			};
			$scope.settingsDropdownProperties.onToggle = function (open) {
				// hide pendo resource center guide when setting dropdown is toggled
				pendo && pendo.hideGuides && pendo.hideGuides();
				if (open) {
					document.addEventListener('click', unfocusSettingsToggle);
					$scope.settingsTooltipProperties.open = false;
					if (settingsTooltipPromise) {
						$timeout.cancel(settingsTooltipPromise);
					}
				} else {
					closeSettingsSubmenus();
					document.removeEventListener('click', unfocusSettingsToggle);
				}
			};
			getCustomersDropdownList();
			getFactoriesDropdownList();
			var origin = location.origin;
			if (!origin) {
				origin = window.location.protocol + '//' + window.location.hostname +
					(window.location.port ? ':' + window.location.port : '');
			}
			if (qpar.path) {
				location.href = origin + location.pathname + '#' + decodeURIComponent(qpar.path);
			}
			if (!$scope.displayTabs.supplierPortal) {
				if (!isLandingPageMyWork) {
					getInventoryActionsNotifications();
				} else {
					notificationService.setAutomaticReloadOfUnreadInventoryActions(true);
				}
			}
			if (window.LEANDNA_DEPLOYMENT_ID) {
				$timeout(getDeploymentId, 5 * 60 * 1000);
			}
			$scope.displayTabs.notificationObject = notificationService.getNotificationObject();
			$rootScope.useVersionB = true;

			if (globalConfig.user.role === 'Supplier') {
				navigationService.goToDefaultSupplierReport('supply-chain', true);
			}
		}

		function closeSettingsDropdownOnEsc(e) {
			if (e.key === 'Escape' || e.key === 'Esc') {
				e.stopPropagation();
				// clicking on toggle causes errors, so click on dropdown then focus on toggle
				var dropdown = document.querySelector('#settingsDropdown');
				dropdown.click();
				var toggle = document.querySelector('#settings-toggle');
				if (toggle) toggle.focus();
			}
		}

		function unfocusSettingsToggle() {
			var toggle = document.querySelector('#settings-toggle');
			if (toggle) toggle.blur();
		}

		function pickRoleModal() {
			if (!globalConfig.user.needsRoleConsolidation) {
				return;
			}
			var pickRoleScope = $scope.$new();
			pickRoleScope.selected = {};
			pickRoleScope.lists = {};
			pickRoleScope.customer = {};
			var opts = {
				scope: pickRoleScope,
				templateUrl: '/application/f/navigation/pick-role.html',
				backdrop: 'static',
				keyboard: false
			};
			var userLastModified;
			userManagementService.loadUser(globalConfig.user.id).then(function (response) {
				userLastModified = response.headers()['last-modified'];
				pickRoleScope.customer = response.data.customer;
			});

			var pickRoleModalInstance;
			userManagementService.getRoles().then(function (data) {
				pickRoleScope.lists.roleType = _.filter(data, function (role) {
					return role.roleType !== 'Supplier';
				});
				pickRoleModalInstance = $uibModal.open(opts);
			});


			pickRoleScope.saveRole = function () {
				pickRoleScope.customer.roleType = pickRoleScope.selected.roleType.roleType;
				userManagementService.saveUser(pickRoleScope.customer, globalConfig.user.id, userLastModified, 'customer');
				pickRoleModalInstance.close();
				pickRoleScope.$destroy();
			};
		}

		init();
		pickRoleModal();
	}
})();
